/* ===========================================================================
   AIRFORMANCE X · MOTION — v2
   ---------------------------------------------------------------------------
   Animación de entrada al hacer scroll, usable de dos maneras:

   1. AUTOMÁTICA — cada sección de contenido entra sola. No hay que tocar nada.
   2. MANUAL — en cualquier bloque Custom Liquid puedes escribir
        class="afx-reveal"    el elemento entra desde abajo
        class="afx-stagger"   sus hijos entran escalonados
      y este fichero se encarga del resto.

   EL FALLO QUE ARREGLA LA v2 (y por qué el diseño es así)
   En la v1 el CSS ocultaba directamente .afx-reveal. Eso funciona cuando es
   la propia JS la que pone la clase, pero rompe en cuanto alguien la escribe
   a mano en el marcado: si la JS no llega a ejecutarse, ese contenido se
   queda invisible PARA SIEMPRE. Inaceptable en una tienda.

   Ahora .afx-reveal es solo un MARCADOR, no esconde nada. Quien esconde es
   la clase .afx-reveal--on, y esa la pone exclusivamente esta JS, un
   instante antes de empezar a observar el elemento. Consecuencia: sin JS,
   con JS rota, o con JS bloqueada por el navegador, todo se ve. El peor caso
   posible es que no haya animación.

   LO QUE NO HACE, A PROPÓSITO
   · No toca el scroll. Ni scroll suave propio, ni rueda interceptada, ni
     preventDefault en touch, ni position:fixed sobre el body.
   · No escucha el evento scroll: usa IntersectionObserver, que el navegador
     evalúa fuera del hilo principal. Coste en scroll: cero.
   · Solo anima opacity y transform, las dos únicas propiedades que no
     obligan al navegador a recalcular el layout.

   CUATRO REDES DE SEGURIDAD
   1. La clase que oculta la pone la JS, nunca el CSS (ver arriba).
   2. Lo que ya está en pantalla al cargar NO se oculta: el contenido above
      the fold aparece instantáneo, sin parpadeo y sin penalizar LCP.
   3. Temporizador de 2,5 s: si el observer no disparara, se revela todo.
   4. Todo envuelto en try/catch; si algo falla, se revela todo y se sale.
   =========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;
  if (!('IntersectionObserver' in window)) return;

  var MAX = 90;          // techo de elementos observados
  var FAILSAFE = 2500;   // ms hasta revelar por la fuerza
  var NEAR = 0.9;        // lo que esté por encima de 0.9*vh se considera visible

  // Secciones full-bleed o críticas: nunca se animan en modo automático.
  var SKIP = /afx-annc|afx-hero|afx-heroSplit|afx-footer|carousel-text|afx-igroll|shopify-section-header|announcement/i;

  var pending = [];

  function hide(el, mode) {
    var onCls = mode === 'stagger' ? 'afx-stagger--on' : 'afx-reveal--on';
    if (el.classList.contains(onCls)) return false;
    // Red 2: si ya se ve, se deja en paz.
    if (el.getBoundingClientRect().top < (window.innerHeight || 800) * NEAR) return false;
    el.classList.add(onCls);
    pending.push(el);
    return true;
  }

  function collectExplicit() {
    // Modo MANUAL: lo que el bloque ya marcó en su propio HTML.
    var nodes = document.querySelectorAll('.afx-reveal, .afx-stagger');
    for (var i = 0; i < nodes.length && pending.length < MAX; i++) {
      var el = nodes[i];
      var mode = el.classList.contains('afx-stagger') ? 'stagger' : 'reveal';
      if (mode === 'stagger' && el.children.length < 2) continue;
      hide(el, mode);
    }
  }

  function collectAuto() {
    // Modo AUTOMÁTICO: un objetivo por sección de contenido — su envoltorio
    // interior, que es donde vive el padding real, no la sección.
    var sections = document.querySelectorAll('.xo-section, .shopify-section');
    for (var i = 0; i < sections.length && pending.length < MAX; i++) {
      var s = sections[i];
      if (SKIP.test(s.className) || SKIP.test(s.id || '')) continue;

      var inner = s.firstElementChild;
      if (!inner) continue;
      if (inner.tagName === 'STYLE' || inner.tagName === 'SCRIPT') {
        inner = inner.nextElementSibling;
        if (!inner) continue;
      }
      if (SKIP.test(inner.className || '')) continue;
      // Si el bloque ya se marcó a mano, no se le añade nada por encima.
      if (inner.querySelector('.afx-reveal, .afx-stagger')) continue;
      if (inner.classList.contains('afx-reveal') || inner.classList.contains('afx-stagger')) continue;

      var h = inner.offsetHeight;
      if (h < 80 || h > 3000) continue;   // ni separadores ni la página entera

      inner.classList.add('afx-reveal');
      hide(inner, 'reveal');
    }
  }

  function show(el) {
    el.classList.add('afx-in');
    // Liberar la capa de composición: will-change permanente consume memoria.
    setTimeout(function () { el.style.willChange = 'auto'; }, 700);
  }

  function run() {
    collectExplicit();
    collectAuto();
    if (!pending.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          show(entries[e].target);
          io.unobserve(entries[e].target);   // una vez revelado, se deja en paz
        }
      }
    }, {
      // Dispara un 12% antes de entrar: el elemento ya está compuesto al verse.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.01
    });

    for (var p = 0; p < pending.length; p++) io.observe(pending[p]);

    // Red 3: pase lo que pase, a los 2,5 s se ve todo.
    setTimeout(function () {
      for (var k = 0; k < pending.length; k++) {
        if (!pending[k].classList.contains('afx-in')) show(pending[k]);
      }
    }, FAILSAFE);
  }

  function revealEverything() {
    var hidden = document.querySelectorAll('.afx-reveal--on, .afx-stagger--on');
    for (var i = 0; i < hidden.length; i++) hidden[i].classList.add('afx-in');
  }

  // Red 4: un fallo aquí no puede dejar la web a medias.
  function boot() {
    try { run(); } catch (err) { revealEverything(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
